import React, { useEffect } from 'react';
import queryString from 'query-string';
import { H } from 'highlight.run';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import { getAnonymousId } from './utils/segment';
import { EmbedPlayer } from 'src/dashboard/embed/player';
import { NeuePlayer } from 'src/editor/content-creation/neue-player';
import { NotificationMessage } from 'src/common/notification/message';
import { apiGetCurrentUser } from './utils/journeyApi';
import { useCurrentUser } from './store/user';
import { LocationChangeListener } from 'src/common/location-change-listener';
import AnalyticsHelper from 'src/common/helpers/analytics';
import { SentryHelper } from './common/sentry';

function EmbedApp() {
  const setCurrentUser = useCurrentUser((state) => state.setCurrentUser);
  const identifyAnonymousUser = () => {
    // Grab the uuid from segment if available
    const anonymousId = getAnonymousId();

    // Sentry identify
    SentryHelper.setUser('', anonymousId);

    // Highlight identify
    H.identify &&
      H.identify(anonymousId, {
        id: anonymousId,
      });
  };

  const queryParams = queryString.parse(window.location.search);
  const uuid = document.getElementsByTagName('body')[0].getAttribute('data-uuid');
  const neue = document.getElementsByTagName('body')[0].getAttribute('data-neue');

  const trackingUUID = queryParams.tracking_uuid_override || null;
  const previewMode = queryParams.preview || false;
  const pdfPreview = !!queryParams.pdf_preview;
  const bypass = queryParams.bypass || null;

  useEffect(() => {
    H.init(process.env.HIGHLIGHT_KEY_PLAYER, {
      environment: process.env.ENVIRONMENT,
    });

    apiGetCurrentUser().then(setCurrentUser).catch(identifyAnonymousUser);

    if (!previewMode) {
      AnalyticsHelper.trackPage();
    }
  }, []);

  return (
    <Router>
      <LocationChangeListener />
      <NotificationMessage />
      <Switch>
        <Route
          path={`/p/:aliasSlug/:stepPath?`}
          render={(props) =>
            neue ? (
              <NeuePlayer 
                token={queryParams.token} 
                uuid={uuid}
                stepPath={props.match.params.stepPath}
                previewMode={queryParams.preview}
                pdfPreview={pdfPreview}
                bypass={bypass}
                trackingUUID={trackingUUID} />
            ) : (
              <EmbedPlayer
                uuid={uuid}
                trackingUUID={trackingUUID}
                startNodeId={queryParams.start || null}
                stepPath={props.match.params.stepPath}
                commentIdToScroll={queryParams.comment || ''}
                suggestedCommenterUserUUID={queryParams.suggested_user_uuid || ''}
                previewMode={queryParams.preview}
                galleryMode={queryParams.gallery}
                token={queryParams.token}
              />
            )
          }
        ></Route>
        <Route
          path={`/e/:aliasSlug/:stepPath?`}
          render={(props) => (
            <EmbedPlayer
              uuid={uuid}
              trackingUUID={trackingUUID}
              startNodeId={queryParams.start || null}
              aliasSlug={props.match.params.aliasSlug}
              stepPath={props.match.params.stepPath}
              commentIdToScroll={queryParams.comment || ''}
              suggestedCommenterUserUUID={queryParams.suggested_user_uuid || ''}
              previewMode={queryParams.preview}
              galleryMode={queryParams.gallery}
              token={queryParams.token}
            />
          )}
        ></Route>
        <Route path='*'>
          <EmbedPlayer
            uuid={uuid}
            trackingUUID={trackingUUID}
            startNodeId={queryParams.start || null}
            commentId={queryParams.comment || ''}
            suggestedCommenterUserUUID={queryParams.suggested_user_uuid || ''}
            previewMode={queryParams.preview}
            galleryMode={queryParams.gallery}
            token={queryParams.token}
          />
        </Route>
      </Switch>
    </Router>
  );
}

export default EmbedApp;
